import React from "react";

const Radical = () => (
  <svg
    width="241px"
    height="281px"
    viewBox="0 0 241 281"
    version="1.1"
    style={{ overflow: "visible" }}
  >
    <g
      id="Davos_Frame_09"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(-1424.000000, -400.000000)"
      stroke-linecap="round"
    >
      <g id="Radical-cure-icon" transform="translate(1425.000000, 401.000000)">
        <g id="microscope">
          <path
            d="M92.6983784,49.5664865 L49.4156757,92.8491892 L142.817838,186.251351 C147.492973,190.926486 155.033514,190.926486 159.708649,186.251351 L186.100541,159.859459 C190.775676,155.184324 190.775676,147.643784 186.100541,142.968649 L92.6983784,49.5664865 Z"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linejoin="round"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-width="1.99998082"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linejoin="round"
            transform="translate(43.493099, 43.648535) rotate(-45.000000) translate(-43.493099, -43.648535) "
            x="29.2667488"
            y="4.6894487"
            width="28.4527001"
            height="77.9181717"
          />
          <path
            d="M26.04,6.03243243 L31.8713514,0.150810811"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M0.0502702703,32.0221622 L5.88162162,26.1405405"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <polygon
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linejoin="round"
            points="182.933514 162.976216 194.395135 174.437838 194.847568 184.894054 184.793514 194.948108 174.287027 194.545946 162.825405 183.084324"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-width="1.99998082"
            fill="#1A1C35"
            fill-rule="nonzero"
            transform="translate(191.416863, 191.520138) rotate(-45.000000) translate(-191.416863, -191.520138) "
            x="187.194201"
            y="189.257998"
            width="8.44532441"
            height="4.52428094"
          />
        </g>
        <path
          d="M78.2205405,278.497297 L160.060541,278.497297"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M119.140541,269.448649 L119.140541,278.497297"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <circle
          id="Oval"
          stroke="#FFFFFF"
          stroke-width="2"
          fill="#1A1C35"
          fill-rule="nonzero"
          cx="119.140541"
          cy="269.448649"
          r="6.28378378"
        />
        <path
          d="M181.928108,225.311351 C184.743243,218.524865 190.071892,213.497838 196.355676,210.883784 C202.639459,208.26973 207.968108,203.242703 210.783243,196.456216 C213.598378,189.66973 218.927027,184.642703 225.210811,182.028649"
          id="Shape"
          stroke="#00D5C1"
          stroke-width="2"
        />
        <path
          d="M219.178378,176.046486 L227.372432,184.240541 C230.338378,187.206486 230.338378,192.032432 227.372432,194.998378 L194.847568,227.523243 C191.881622,230.489189 187.055676,230.489189 184.08973,227.523243 L175.945946,219.329189"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
        />
        <path
          d="M211.135135,211.235676 L215.659459,215.76"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <circle
          id="Oval"
          stroke="#FFFFFF"
          stroke-width="2"
          fill="#1A1C35"
          fill-rule="nonzero"
          cx="100.339459"
          cy="143.722703"
          r="20.3091892"
        />
        <path
          d="M112.354054,269.599459 C102.702162,266.382162 93.6535135,260.952973 85.9621622,253.311892 C59.6708108,227.020541 59.6708108,184.391351 85.9621622,158.1"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
        />
        <path
          d="M86.0124324,158.1 C86.0124324,176.297838 93.2513514,193.741622 106.120541,206.610811 L135.126486,235.616757 C151.916757,252.407027 179.112973,252.407027 195.852973,235.616757 L238.281081,193.188649"
          id="Shape"
          stroke="#FFFFFF"
          stroke-width="2"
        />
      </g>
    </g>
  </svg>
);

export default Radical;



// WEBPACK FOOTER //
// ./src/components/tools/radical.js